import { isNumber } from 'lodash';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { OrderStatus } from 'enums';
import { useCurrencies } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { PayinOrder, ResolvePayinOrderDispute } from 'types';
import { formatUtils } from 'utils';

// A dispute resolved on a provider order may complete with negative profit (e.g. after
// reassignment to a more expensive provider) — the platform takes the loss, so say it explicitly
export const useReassignmentLossNotifier = () => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders.resolve',
  });
  const { getAssetCurrencyCode } = useCurrencies();

  return useCallback(
    (order: PayinOrder | undefined, data: ResolvePayinOrderDispute) => {
      if (
        data.status !== OrderStatus.Completed ||
        !order?.p2pProviderOrderId ||
        !isNumber(order.platformCompensation) ||
        order.platformCompensation >= 0
      ) {
        return;
      }
      toast.warning(
        t('completed_with_loss', {
          amount: formatUtils.formatMoney(order.platformCompensation),
          currency: getAssetCurrencyCode(order.assetCurrencyId),
        }),
        { autoClose: false },
      );
    },
    [t, getAssetCurrencyCode],
  );
};
